// extracted by mini-css-extract-plugin
export default {"nameContainer":"nameDisplay_nameContainer__zhiji","loopName":"nameDisplay_loopName__ABkx8","loopNameDark":"nameDisplay_loopNameDark__GM4k5"};